import { render, staticRenderFns } from "./tchTree.vue?vue&type=template&id=47d4f0ad&scoped=true"
import script from "./tchTree.vue?vue&type=script&lang=js"
export * from "./tchTree.vue?vue&type=script&lang=js"
import style0 from "./tchTree.vue?vue&type=style&index=0&id=47d4f0ad&prod&lang=css"
import style1 from "./tchTree.vue?vue&type=style&index=1&id=47d4f0ad&prod&lang=less"
import style2 from "./tchTree.vue?vue&type=style&index=2&id=47d4f0ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4f0ad",
  null
  
)

export default component.exports